import {hashCode, isDefined} from "../utils";

import {uuid} from 'vue-uuid';

export class BaseVueEntity {

    vueId;

    constructor() {
        this.vueId = uuid.v4();
    }

    //If vueId should be based on some property of Parent
    generateVueIdBasedOnProperty(property) {
        if (!isDefined(this[property])) {
            throw new Error(`Property ${property} is not defined!`);
        }
        this.vueId = hashCode(this[property]);
    }

    reload() {
        this.vueId = uuid.v4();
    }
}
